

import React from 'react'
import { FaBolt} from 'react-icons/fa6'
 //  bg-gradient-to-r from-green-200  via-white to-green-200
export default function Hero() {
  return (
    <div id='hero' className='lg:h-[30em] w-[100%] lg:flex lg:flex-col  mb-[10em] lg:mb-[5em]' >

      <div className="hero_text mt-[3em]  lg:w-1/2 m-auto">

              <div className="font-[Lexend] m-auto justify-center py-[.25em] flex  text-sm mt-[.em] w-[90%] lg:w-[25em] px-[1.75em] leading-[2em] lg:m-auto border rounded-full border-black mb-[3em]">
                <FaBolt className='text-black mt-[.4em] lg:-ml-1'/>
                <p className='font-extralight'>Our Services </p>
                  </div>
        

        <p className='text-3xl  font-black pr-[1em] ml-[1.5em] leading-[1.5em] lg:ml-[5.5em] mt-[1.25em] font-[Satoshi] w-[90%] lg:w-[60%] lg:-indent-10'>
        We help you prevent the stress of owing rent. 
          </p>
        <p className="font-[Lexend] text-sm w-[85%]  mt-[1em]  pr-[1.75em] leading-[2em] lg:ml-[5em] ml-[2.75em] md:ml-[3.4em] -indent-30">Building a platform where we manage rent for landlords to make paying rent easier for tenants and reduce pressure..</p>
        
        
      </div>

    
    </div>
  )
}


